import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { useI18n } from '@openclassrooms/translations/I18nProvider';
import fAQSrc from '@classify/illustrations/fAQ';
import Typography from '@classify/react-core-components/Typography';
import { ImageCdn } from '@openclassrooms/images-cdn';
import FAQ from '@classify/react-marketing-components/FAQ';
import Button from '@classify/react-core-components/Button';
import Box from '@classify/react-core-components/Box';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import EnrichText from '@classify/react-core-components/EnrichText';
import Stack from '@classify/react-core-components/Stack';

import ContactChannelButtonPhone from './ContactChannelButtonPhone';
import ContactChannelExternalForm from './ContactChannelExternalForm';

import { type PageType } from './Dialog';

export default function PageMain({ onChangePage }: { onChangePage: (page: PageType) => void }) {
  const { translate } = useI18n();
  const { getLocalisationConfig } = useLocalisationConfig();

  const channels = [];

  if (getLocalisationConfig('contact.phone.number')) {
    channels.push(<ContactChannelButtonPhone key="phone" onClick={() => onChangePage('phone')} />);
  }

  if (getLocalisationConfig('contact.genericForm.url')) {
    channels.push(<ContactChannelExternalForm key="generic-form" />);
  }

  return (
    <>
      <ImageCdn src={fAQSrc} width={82} height={96} />
      <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
        {translate('support.global.title')}
      </Typography>

      <Stack spacing={4}>
        <EnrichText>
          <Typography
            dangerouslySetInnerHTML={{ __html: translate('support.global.subheading') }}
          />
        </EnrichText>

        {channels.length > 0 && <Stack spacing={2}>{channels}</Stack>}

        <Typography variant="h5" component="h2">
          {translate('support.global.faq.title')}
        </Typography>

        <FAQ
          expandAriaLabel={translate('support.global.subheading')}
          items={[
            {
              question: translate('support.global.faq.options_funding.question'),
              answer: translate('support.global.faq.options_funding.answer'),
            },
            {
              question: translate('support.global.faq.using_cpf.question'),
              answer: translate('support.global.faq.using_cpf.answer'),
            },
            {
              question: translate('support.global.faq.prerequisites.question'),
              answer: translate('support.global.faq.prerequisites.answer'),
            },
            {
              question: translate('support.global.faq.prep_documents.question'),
              answer: translate('support.global.faq.prep_documents.answer'),
            },
            {
              question: translate('support.global.faq.detailed_info_program.question'),
              answer: translate('support.global.faq.detailed_info_program.answer'),
            },
            {
              question: translate('support.global.faq.training_costs_devis.question'),
              answer: translate('support.global.faq.training_costs_devis.answer'),
            },
            {
              question: translate('support.global.faq.connection_issue.question'),
              answer: translate('support.global.faq.connection_issue.answer'),
            },
            {
              question: translate('support.global.faq.state_recognition.question'),
              answer: translate('support.global.faq.state_recognition.answer'),
            },
          ]}
        />

        <Box sx={{ textAlign: 'right' }}>
          <Button
            variant="tertiary"
            endIcon={<OpenInNewIcon />}
            target="_blank"
            href={getLocalisationConfig('faq.student.url')}
          >
            {translate('global.word.see_faq.action')}
          </Button>
        </Box>
      </Stack>
    </>
  );
}
